import { FirebaseService } from 'app/services/firebase.service';

import { Tombstone } from './../../../models/Tombstone';

import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Person } from 'app/models/Person';
import { Component, OnInit } from '@angular/core';
import { BackendService } from 'app/services/backend.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css'],
})
export class DetailsComponent implements OnInit {
  name: string = '';
  extra: string = "";
  map: any;
  lat = undefined;
  lng = undefined;
  hasLatLon: boolean = false;
  tombstone: Tombstone;
  peopleDataSource = new MatTableDataSource<Person>();
  images: Array<String>;
  displayedColumns: string[] = [
    'lastName',
    'firstName',
    'birthDate',
    'dateOfDeath',
    'extraInfo',
  ];
  constructor(
    private route: ActivatedRoute,
    private firebaseService: FirebaseService,
    private imagesService: BackendService
  ) {}

  mapReady(map) {
    this.map = map;
    this.map.setCenter({ lat: this.lat, lng: this.lng });
    this.map.setZoom(15);
  }

  ngOnInit(): void {
    this.images = [];  
    this.name = this.route.snapshot.params.id;
    this.firebaseService.getTombstone(this.name).subscribe((res) => {
      this.tombstone = res as Tombstone;
      this.extra = this.tombstone.extraInfo;
      this.lat = this.tombstone.lat;
      this.lng = this.tombstone.lon;
      if(this.lat!=undefined) this.hasLatLon = true;
      this.peopleDataSource.data = (res as Tombstone).person as Person[];
      if ((res as Tombstone).photos) {
        (res as Tombstone).photos.forEach((image) => {
          // this.imagesService.getImage(image.photoUriBackend).subscribe((i) => {
          //   console.log(i);
          //   this.images.push(i as String);
          // });

          this.images.push(
            `http://51.75.62.77:8040/api/Images/` + image.photoUriBackend
          );
        });
      }
    });
  }
}
